import type { FC, ReactNode } from 'react'
import type { ArticleSummary } from '@/types'

import { CtaLink } from '@/components/generals/cta-link'
import { Outline } from '@/components/generals/mark'
import { SectionLabel } from '@/components/generals/section-label'
import ArticleCard from '@/components/sections/article-card'

interface InsightsPreviewProps {
    articles: ArticleSummary[]
}

const InsightsPreview: FC<InsightsPreviewProps> = ({ articles }): ReactNode => {
    if (!articles.length) return null

    const [first, ...rest] = articles

    return (
        <section id='insights' aria-labelledby='insights-title' data-nav-theme='light' className='bg-coral text-charcoal'>
            <div className='mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28'>
                <div className='flex flex-col gap-10 md:flex-row md:items-end md:justify-between'>
                    <div data-reveal>
                        <SectionLabel className='text-charcoal'>Insights / 06</SectionLabel>
                        <h2 id='insights-title' className='mt-6 font-heading type-section'>
                            <span className='md:block'>Thinking beyond</span>{' '}
                            <span className='md:block'><Outline>the campaign.</Outline></span>
                        </h2>
                    </div>
                    <div data-reveal>
                        <CtaLink href='/insights' variant='dark'>Explore all insights</CtaLink>
                    </div>
                </div>

                <div className='mt-14 grid gap-14 md:mt-16 lg:grid-cols-12 lg:gap-10'>
                    <ArticleCard article={first} variant='feature' className='lg:col-span-7' />

                    <div className='flex flex-col gap-8 border-t border-charcoal pt-8 lg:col-span-5'>
                        {rest.map((article) => (
                            <div key={article.id} className='border-b border-charcoal/25 pb-8 last:border-b-0'>
                                <ArticleCard article={article} variant='row' />
                                <p className='mt-4 text-[15px] leading-relaxed text-charcoal/85'>{article.excerpt}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default InsightsPreview
